import React, {useEffect} from "react";
import {useStoreGlobal} from '../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import PruebasBoton from "./pruebas/PruebasBoton";
export default function PruebaReact(){
// const _filtros= useStoreGlobal(useShallow((state) => state._filtros));
// const _totalBotonClic= useStoreGlobal(useShallow((state) => state._totalBotonClic));
       
// let coleccion = "";
// let camposBuscador = "";
// let camposOrden = "";
// let ordenamiento = "";
// let pageFin = 0;
// let paginaInicial = 0;
// let metodoBusqueda = 1;
// let radioIndicador ="";
let botonConsulta = 0;
// let textoBusqueda = "";
// let var_area_final= null;
// let apiDataGeo = "";
// if(Object.keys(_filtros).length > 0){
//     coleccion = _filtros.coleccion;
//     camposBuscador = _filtros.camposBuscador;
//     camposOrden = _filtros.camposOrden;
//     ordenamiento = _filtros.ordenamiento;
//     pageFin = _filtros.paginaFin;
//     paginaInicial = _filtros.paginaInicial;
//     metodoBusqueda = _filtros.metodoBusqueda;
//     radioIndicador =_filtros.radioIndicador;
//     textoBusqueda = _filtros.textoBusqueda;
// }
// if(Object.keys(_totalBotonClic).length > 0){
//     botonConsulta =_totalBotonClic.botonConsulta;
//     console.log(_totalBotonClic);
// }
console.log("PruebaReact");
return(
        <div id="contextsearchresults" style={{display:"block"}} className="col-xs-12 todo">
        {
             <PruebasBoton />
        }
        </div>  
    )
}